/**
 * Standardized cache timing constants for React Query.
 *
 * REALTIME  - Data that changes every few seconds (job progress, polling)
 * FREQUENT  - Data that changes within a session (deal lists, activities)
 * STANDARD  - Default for most data (campaigns, contacts)
 * STABLE    - Data that rarely changes (billing, config, channel types)
 * STATIC    - Data that never changes (enum values, industry codes)
 */
export const STALE_TIMES = {
	REALTIME: 2_000,
	FREQUENT: 30_000,
	STANDARD: 60_000,
	STABLE: 5 * 60_000,
	STATIC: Infinity,
};
